import { gql } from '@apollo/client';

export * from './escrowMemberRemove.mutation.generated';

export const ESCROW_MEMBER_REMOVE = gql`
  mutation escrowMemberRemove($escrowMemberId: ID!) {
    escrowMemberRemove(input: { escrowMemberId: $escrowMemberId }) {
      errors
      success
    }
  }
`;
